import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"error\"><path fill-rule=\"evenodd\" d=\"M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z\" clip-rule=\"evenodd\" /><mask id=\"error_a\" width=\"22\" height=\"19\" x=\"1\" y=\"2\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><path fill-rule=\"evenodd\" d=\"M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z\" clip-rule=\"evenodd\" /></mask></symbol>"
});
var result = sprite.add(symbol);
export default symbol